//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class V1DealsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    //custom code to format date without localization
    formatDateToLocalISO(date: Date): string {
        const pad = (num: number) => num.toString().padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    /**
     * @return OK
     */
    apiTest( cancelToken?: CancelToken): Promise<TestDto> {
        let url_ = this.baseUrl + "/api/v1/deals/tests";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiTest(_response);
        });
    }

    protected processApiTest(response: AxiosResponse): Promise<TestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = TestDto.fromJS(resultData200);
            return Promise.resolve<TestDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestDto>(null as any);
    }

    /**
     * @param migrationStatus (optional) 
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @return OK
     */
    getMigrationDealsByDealerId(dealerId: number, deletedState: DeletedStateEnum, migrationStatus?: F4MigrationStatusEnum | null | undefined, search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, cancelToken?: CancelToken): Promise<F4MigrationDealerDealDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/deals/dealers/{dealerId}?";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                                    if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                            if (migrationStatus !== undefined && migrationStatus !== null)
                            url_ += "migrationStatus=" + encodeURIComponent("" + migrationStatus) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMigrationDealsByDealerId(_response);
        });
    }

    protected processGetMigrationDealsByDealerId(response: AxiosResponse): Promise<F4MigrationDealerDealDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = F4MigrationDealerDealDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<F4MigrationDealerDealDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<F4MigrationDealerDealDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @return OK
     */
    getF4migrationQueueResults(dealerDealId: number, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, cancelToken?: CancelToken): Promise<F4MigrationQueueResultDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealerDealId}?";

                    if (dealerDealId === undefined || dealerDealId === null)
                throw new Error("The parameter 'dealerDealId' must be defined.");
                    url_ = url_.replace("{dealerDealId}", encodeURIComponent("" + dealerDealId));
                                    if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetF4migrationQueueResults(_response);
        });
    }

    protected processGetF4migrationQueueResults(response: AxiosResponse): Promise<F4MigrationQueueResultDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = F4MigrationQueueResultDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<F4MigrationQueueResultDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<F4MigrationQueueResultDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    queueMigrationToF4Sales(dealerId: number, body?: BulkIdsDto | undefined, cancelToken?: CancelToken): Promise<BulkApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/deals/dealers/{dealerId}/queue-deal-migration-to-frazer-one-sales";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                            url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueueMigrationToF4Sales(_response);
        });
    }

    protected processQueueMigrationToF4Sales(response: AxiosResponse): Promise<BulkApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = BulkApiResponseDto.fromJS(resultData200);
            return Promise.resolve<BulkApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    queueDealMigrations(dealerId: number, body?: QueueDealMigrationRequestDto | undefined, cancelToken?: CancelToken): Promise<BulkApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/deals/dealers/{dealerId}/queue-deal-migrations";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                            url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueueDealMigrations(_response);
        });
    }

    protected processQueueDealMigrations(response: AxiosResponse): Promise<BulkApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = BulkApiResponseDto.fromJS(resultData200);
            return Promise.resolve<BulkApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkApiResponseDto>(null as any);
    }

    /**
     * @param forceResync (optional) 
     * @return OK
     */
    queueAllDealMigrationsToF4Sales(dealerId: number, deletedState: DeletedStateEnum, forceResync?: boolean | null | undefined, cancelToken?: CancelToken): Promise<QueueAllMigrationResultDto> {
        let url_ = this.baseUrl + "/api/v1/deals/dealers/{dealerId}/queue-all-deal-migrations-to-frazer-one-sales?";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                                    if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                            if (forceResync !== undefined && forceResync !== null)
                            url_ += "forceResync=" + encodeURIComponent("" + forceResync) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueueAllDealMigrationsToF4Sales(_response);
        });
    }

    protected processQueueAllDealMigrationsToF4Sales(response: AxiosResponse): Promise<QueueAllMigrationResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = QueueAllMigrationResultDto.fromJS(resultData200);
            return Promise.resolve<QueueAllMigrationResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueueAllMigrationResultDto>(null as any);
    }
}

export class ApiResponseDto implements IApiResponseDto {
    id!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): ApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): ApiResponseDto {
        const json = this.toJSON();
        let result = new ApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IApiResponseDto {
    id: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class BulkApiResponseDto implements IBulkApiResponseDto {
    statusCode!: HttpStatusCode;
    readonly success!: boolean;
    readonly errors?: string[] | undefined;
    readonly status?: string | undefined;
    responses?: ApiResponseDto[] | undefined;

    constructor(data?: IBulkApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            (<any>this).success = _data["success"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).status = _data["status"];
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(ApiResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["success"] = this.success;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["status"] = this.status;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        return data;
    }

    clone(): BulkApiResponseDto {
        const json = this.toJSON();
        let result = new BulkApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IBulkApiResponseDto {
    statusCode: HttpStatusCode;
    success: boolean;
    errors?: string[] | undefined;
    status?: string | undefined;
    responses?: ApiResponseDto[] | undefined;
}

export class BulkIdsDto implements IBulkIdsDto {
    ids?: number[] | undefined;

    constructor(data?: IBulkIdsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkIdsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkIdsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }

    clone(): BulkIdsDto {
        const json = this.toJSON();
        let result = new BulkIdsDto();
        result.init(json);
        return result;
    }
}

export interface IBulkIdsDto {
    ids?: number[] | undefined;
}

export enum DealStatusEnum {
    InProgress = "InProgress",
    OnHold = "OnHold",
    Closed = "Closed",
    Cancelled = "Cancelled",
}

export enum DeletedStateEnum {
    Undefined = "Undefined",
    Active = "Active",
    Deleted = "Deleted",
    Both = "Both",
}

export class F4MigrationDealerDealDto implements IF4MigrationDealerDealDto {
    dealerDealId!: number;
    inventoryId?: number | undefined;
    dealerId?: number | undefined;
    customerBuyerId?: number | undefined;
    customerBuyerFirstName?: string | undefined;
    customerBuyerLastName?: string | undefined;
    customerBuyerFullName?: string | undefined;
    customerCoBuyerId?: number | undefined;
    dealStatusId?: DealStatusEnum | undefined;
    dealStatusReasonId!: number;
    purchaseAmount?: number | undefined;
    downPayment?: number | undefined;
    salesTax?: number | undefined;
    totalPurchaseAmount?: number | undefined;
    profit?: number | undefined;
    finalCost?: number | undefined;
    createdById!: number;
    createdDate!: Date;
    lastModifiedById!: number;
    lastModifiedDate!: Date;
    dealClosedDay!: number;
    dealClosedMonth!: number;
    dealClosedYear!: number;
    inventoryPurchaseDate!: Date;
    deleted!: boolean;
    dealerSalesTypeId?: number | undefined;
    reactivatedInventoryReasonId?: number | undefined;
    salesPersonUserId?: number | undefined;
    lienHolderId?: number | undefined;
    dateOfLien?: Date | undefined;
    lienHolderAccountNumber?: string | undefined;
    lienHolderPhoneNumber?: string | undefined;
    lienHolderContactName?: string | undefined;
    dealClosedDate?: Date | undefined;
    dealStatusName?: string | undefined;
    dealStatusReasonName?: string | undefined;
    salesPersonName?: string | undefined;
    vehicleStock?: string | undefined;
    vehicleYear?: number | undefined;
    vehicleMake?: string | undefined;
    vehicleModel?: string | undefined;
    vehicleTrim?: string | undefined;
    f4migrationQueueResultCount!: number;
    f4migrationQueueCount!: number;
    latestF4migrationQueueId?: number | undefined;
    latestF4migrationQueueDate?: Date | undefined;
    latestF4migrationQueueResultSaleId?: number | undefined;
    latestF4migrationQueueResultStatusId?: F4MigrationQueueResultStatusEnum | undefined;
    latestF4migrationQueueResultMessage?: string | undefined;
    readonly migrationBlockedReasons?: string[] | undefined;
    readonly isMigratable!: boolean;
    readonly vehicleTitle?: string | undefined;

    constructor(data?: IF4MigrationDealerDealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerDealId = _data["dealerDealId"];
            this.inventoryId = _data["inventoryId"];
            this.dealerId = _data["dealerId"];
            this.customerBuyerId = _data["customerBuyerId"];
            this.customerBuyerFirstName = _data["customerBuyerFirstName"];
            this.customerBuyerLastName = _data["customerBuyerLastName"];
            this.customerBuyerFullName = _data["customerBuyerFullName"];
            this.customerCoBuyerId = _data["customerCoBuyerId"];
            this.dealStatusId = _data["dealStatusId"];
            this.dealStatusReasonId = _data["dealStatusReasonId"];
            this.purchaseAmount = _data["purchaseAmount"];
            this.downPayment = _data["downPayment"];
            this.salesTax = _data["salesTax"];
            this.totalPurchaseAmount = _data["totalPurchaseAmount"];
            this.profit = _data["profit"];
            this.finalCost = _data["finalCost"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedById = _data["lastModifiedById"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.dealClosedDay = _data["dealClosedDay"];
            this.dealClosedMonth = _data["dealClosedMonth"];
            this.dealClosedYear = _data["dealClosedYear"];
            this.inventoryPurchaseDate = _data["inventoryPurchaseDate"] ? new Date(_data["inventoryPurchaseDate"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.dealerSalesTypeId = _data["dealerSalesTypeId"];
            this.reactivatedInventoryReasonId = _data["reactivatedInventoryReasonId"];
            this.salesPersonUserId = _data["salesPersonUserId"];
            this.lienHolderId = _data["lienHolderId"];
            this.dateOfLien = _data["dateOfLien"] ? new Date(_data["dateOfLien"].toString()) : <any>undefined;
            this.lienHolderAccountNumber = _data["lienHolderAccountNumber"];
            this.lienHolderPhoneNumber = _data["lienHolderPhoneNumber"];
            this.lienHolderContactName = _data["lienHolderContactName"];
            this.dealClosedDate = _data["dealClosedDate"] ? new Date(_data["dealClosedDate"].toString()) : <any>undefined;
            this.dealStatusName = _data["dealStatusName"];
            this.dealStatusReasonName = _data["dealStatusReasonName"];
            this.salesPersonName = _data["salesPersonName"];
            this.vehicleStock = _data["vehicleStock"];
            this.vehicleYear = _data["vehicleYear"];
            this.vehicleMake = _data["vehicleMake"];
            this.vehicleModel = _data["vehicleModel"];
            this.vehicleTrim = _data["vehicleTrim"];
            this.f4migrationQueueResultCount = _data["f4migrationQueueResultCount"];
            this.f4migrationQueueCount = _data["f4migrationQueueCount"];
            this.latestF4migrationQueueId = _data["latestF4migrationQueueId"];
            this.latestF4migrationQueueDate = _data["latestF4migrationQueueDate"] ? new Date(_data["latestF4migrationQueueDate"].toString()) : <any>undefined;
            this.latestF4migrationQueueResultSaleId = _data["latestF4migrationQueueResultSaleId"];
            this.latestF4migrationQueueResultStatusId = _data["latestF4migrationQueueResultStatusId"];
            this.latestF4migrationQueueResultMessage = _data["latestF4migrationQueueResultMessage"];
            if (Array.isArray(_data["migrationBlockedReasons"])) {
                (<any>this).migrationBlockedReasons = [] as any;
                for (let item of _data["migrationBlockedReasons"])
                    (<any>this).migrationBlockedReasons!.push(item);
            }
            (<any>this).isMigratable = _data["isMigratable"];
            (<any>this).vehicleTitle = _data["vehicleTitle"];
        }
    }

    static fromJS(data: any): F4MigrationDealerDealDto {
        data = typeof data === 'object' ? data : {};
        let result = new F4MigrationDealerDealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerDealId"] = this.dealerDealId;
        data["inventoryId"] = this.inventoryId;
        data["dealerId"] = this.dealerId;
        data["customerBuyerId"] = this.customerBuyerId;
        data["customerBuyerFirstName"] = this.customerBuyerFirstName;
        data["customerBuyerLastName"] = this.customerBuyerLastName;
        data["customerBuyerFullName"] = this.customerBuyerFullName;
        data["customerCoBuyerId"] = this.customerCoBuyerId;
        data["dealStatusId"] = this.dealStatusId;
        data["dealStatusReasonId"] = this.dealStatusReasonId;
        data["purchaseAmount"] = this.purchaseAmount;
        data["downPayment"] = this.downPayment;
        data["salesTax"] = this.salesTax;
        data["totalPurchaseAmount"] = this.totalPurchaseAmount;
        data["profit"] = this.profit;
        data["finalCost"] = this.finalCost;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedById"] = this.lastModifiedById;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["dealClosedDay"] = this.dealClosedDay;
        data["dealClosedMonth"] = this.dealClosedMonth;
        data["dealClosedYear"] = this.dealClosedYear;
        data["inventoryPurchaseDate"] = this.inventoryPurchaseDate ? this.inventoryPurchaseDate.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["dealerSalesTypeId"] = this.dealerSalesTypeId;
        data["reactivatedInventoryReasonId"] = this.reactivatedInventoryReasonId;
        data["salesPersonUserId"] = this.salesPersonUserId;
        data["lienHolderId"] = this.lienHolderId;
        data["dateOfLien"] = this.dateOfLien ? this.dateOfLien.toISOString() : <any>undefined;
        data["lienHolderAccountNumber"] = this.lienHolderAccountNumber;
        data["lienHolderPhoneNumber"] = this.lienHolderPhoneNumber;
        data["lienHolderContactName"] = this.lienHolderContactName;
        data["dealClosedDate"] = this.dealClosedDate ? this.dealClosedDate.toISOString() : <any>undefined;
        data["dealStatusName"] = this.dealStatusName;
        data["dealStatusReasonName"] = this.dealStatusReasonName;
        data["salesPersonName"] = this.salesPersonName;
        data["vehicleStock"] = this.vehicleStock;
        data["vehicleYear"] = this.vehicleYear;
        data["vehicleMake"] = this.vehicleMake;
        data["vehicleModel"] = this.vehicleModel;
        data["vehicleTrim"] = this.vehicleTrim;
        data["f4migrationQueueResultCount"] = this.f4migrationQueueResultCount;
        data["f4migrationQueueCount"] = this.f4migrationQueueCount;
        data["latestF4migrationQueueId"] = this.latestF4migrationQueueId;
        data["latestF4migrationQueueDate"] = this.latestF4migrationQueueDate ? this.latestF4migrationQueueDate.toISOString() : <any>undefined;
        data["latestF4migrationQueueResultSaleId"] = this.latestF4migrationQueueResultSaleId;
        data["latestF4migrationQueueResultStatusId"] = this.latestF4migrationQueueResultStatusId;
        data["latestF4migrationQueueResultMessage"] = this.latestF4migrationQueueResultMessage;
        if (Array.isArray(this.migrationBlockedReasons)) {
            data["migrationBlockedReasons"] = [];
            for (let item of this.migrationBlockedReasons)
                data["migrationBlockedReasons"].push(item);
        }
        data["isMigratable"] = this.isMigratable;
        data["vehicleTitle"] = this.vehicleTitle;
        return data;
    }

    clone(): F4MigrationDealerDealDto {
        const json = this.toJSON();
        let result = new F4MigrationDealerDealDto();
        result.init(json);
        return result;
    }
}

export interface IF4MigrationDealerDealDto {
    dealerDealId: number;
    inventoryId?: number | undefined;
    dealerId?: number | undefined;
    customerBuyerId?: number | undefined;
    customerBuyerFirstName?: string | undefined;
    customerBuyerLastName?: string | undefined;
    customerBuyerFullName?: string | undefined;
    customerCoBuyerId?: number | undefined;
    dealStatusId?: DealStatusEnum | undefined;
    dealStatusReasonId: number;
    purchaseAmount?: number | undefined;
    downPayment?: number | undefined;
    salesTax?: number | undefined;
    totalPurchaseAmount?: number | undefined;
    profit?: number | undefined;
    finalCost?: number | undefined;
    createdById: number;
    createdDate: Date;
    lastModifiedById: number;
    lastModifiedDate: Date;
    dealClosedDay: number;
    dealClosedMonth: number;
    dealClosedYear: number;
    inventoryPurchaseDate: Date;
    deleted: boolean;
    dealerSalesTypeId?: number | undefined;
    reactivatedInventoryReasonId?: number | undefined;
    salesPersonUserId?: number | undefined;
    lienHolderId?: number | undefined;
    dateOfLien?: Date | undefined;
    lienHolderAccountNumber?: string | undefined;
    lienHolderPhoneNumber?: string | undefined;
    lienHolderContactName?: string | undefined;
    dealClosedDate?: Date | undefined;
    dealStatusName?: string | undefined;
    dealStatusReasonName?: string | undefined;
    salesPersonName?: string | undefined;
    vehicleStock?: string | undefined;
    vehicleYear?: number | undefined;
    vehicleMake?: string | undefined;
    vehicleModel?: string | undefined;
    vehicleTrim?: string | undefined;
    f4migrationQueueResultCount: number;
    f4migrationQueueCount: number;
    latestF4migrationQueueId?: number | undefined;
    latestF4migrationQueueDate?: Date | undefined;
    latestF4migrationQueueResultSaleId?: number | undefined;
    latestF4migrationQueueResultStatusId?: F4MigrationQueueResultStatusEnum | undefined;
    latestF4migrationQueueResultMessage?: string | undefined;
    migrationBlockedReasons?: string[] | undefined;
    isMigratable: boolean;
    vehicleTitle?: string | undefined;
}

export class F4MigrationDealerDealDtoPagedDataResponseDto implements IF4MigrationDealerDealDtoPagedDataResponseDto {
    data!: F4MigrationDealerDealDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IF4MigrationDealerDealDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(F4MigrationDealerDealDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): F4MigrationDealerDealDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new F4MigrationDealerDealDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): F4MigrationDealerDealDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new F4MigrationDealerDealDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IF4MigrationDealerDealDtoPagedDataResponseDto {
    data: F4MigrationDealerDealDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class F4MigrationQueueResultDto implements IF4MigrationQueueResultDto {
    f4migrationQueueResultId!: number;
    f4migrationQueueId!: number;
    dealerId!: number;
    refId!: number;
    f4migrationQueueResultStatusId!: F4MigrationQueueResultStatusEnum;
    message?: string | undefined;
    processedDate!: Date;
    f4migrationQueueResultStatusName?: string | undefined;
    f4saleId?: number | undefined;
    dealStatusId?: DealStatusEnum | undefined;

    constructor(data?: IF4MigrationQueueResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.f4migrationQueueResultId = _data["f4migrationQueueResultId"];
            this.f4migrationQueueId = _data["f4migrationQueueId"];
            this.dealerId = _data["dealerId"];
            this.refId = _data["refId"];
            this.f4migrationQueueResultStatusId = _data["f4migrationQueueResultStatusId"];
            this.message = _data["message"];
            this.processedDate = _data["processedDate"] ? new Date(_data["processedDate"].toString()) : <any>undefined;
            this.f4migrationQueueResultStatusName = _data["f4migrationQueueResultStatusName"];
            this.f4saleId = _data["f4saleId"];
            this.dealStatusId = _data["dealStatusId"];
        }
    }

    static fromJS(data: any): F4MigrationQueueResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new F4MigrationQueueResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["f4migrationQueueResultId"] = this.f4migrationQueueResultId;
        data["f4migrationQueueId"] = this.f4migrationQueueId;
        data["dealerId"] = this.dealerId;
        data["refId"] = this.refId;
        data["f4migrationQueueResultStatusId"] = this.f4migrationQueueResultStatusId;
        data["message"] = this.message;
        data["processedDate"] = this.processedDate ? this.processedDate.toISOString() : <any>undefined;
        data["f4migrationQueueResultStatusName"] = this.f4migrationQueueResultStatusName;
        data["f4saleId"] = this.f4saleId;
        data["dealStatusId"] = this.dealStatusId;
        return data;
    }

    clone(): F4MigrationQueueResultDto {
        const json = this.toJSON();
        let result = new F4MigrationQueueResultDto();
        result.init(json);
        return result;
    }
}

export interface IF4MigrationQueueResultDto {
    f4migrationQueueResultId: number;
    f4migrationQueueId: number;
    dealerId: number;
    refId: number;
    f4migrationQueueResultStatusId: F4MigrationQueueResultStatusEnum;
    message?: string | undefined;
    processedDate: Date;
    f4migrationQueueResultStatusName?: string | undefined;
    f4saleId?: number | undefined;
    dealStatusId?: DealStatusEnum | undefined;
}

export class F4MigrationQueueResultDtoPagedDataResponseDto implements IF4MigrationQueueResultDtoPagedDataResponseDto {
    data!: F4MigrationQueueResultDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IF4MigrationQueueResultDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(F4MigrationQueueResultDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): F4MigrationQueueResultDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new F4MigrationQueueResultDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): F4MigrationQueueResultDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new F4MigrationQueueResultDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IF4MigrationQueueResultDtoPagedDataResponseDto {
    data: F4MigrationQueueResultDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export enum F4MigrationQueueResultStatusEnum {
    Undefined = "Undefined",
    Success = "Success",
    Failed = "Failed",
    PartialSuccess = "PartialSuccess",
}

export enum F4MigrationStatusEnum {
    Undefined = "Undefined",
    All = "All",
    NotMigrated = "NotMigrated",
    Queued = "Queued",
    Success = "Success",
    Failed = "Failed",
    PartialSuccess = "PartialSuccess",
    Ineligible = "Ineligible",
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class QueueAllMigrationResultDto implements IQueueAllMigrationResultDto {
    eligible!: number;
    queued!: number;
    skippedAlreadyMigrated!: number;
    skippedPending!: number;
    skippedIneligible!: number;

    constructor(data?: IQueueAllMigrationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eligible = _data["eligible"];
            this.queued = _data["queued"];
            this.skippedAlreadyMigrated = _data["skippedAlreadyMigrated"];
            this.skippedPending = _data["skippedPending"];
            this.skippedIneligible = _data["skippedIneligible"];
        }
    }

    static fromJS(data: any): QueueAllMigrationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueueAllMigrationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eligible"] = this.eligible;
        data["queued"] = this.queued;
        data["skippedAlreadyMigrated"] = this.skippedAlreadyMigrated;
        data["skippedPending"] = this.skippedPending;
        data["skippedIneligible"] = this.skippedIneligible;
        return data;
    }

    clone(): QueueAllMigrationResultDto {
        const json = this.toJSON();
        let result = new QueueAllMigrationResultDto();
        result.init(json);
        return result;
    }
}

export interface IQueueAllMigrationResultDto {
    eligible: number;
    queued: number;
    skippedAlreadyMigrated: number;
    skippedPending: number;
    skippedIneligible: number;
}

export class QueueDealMigrationRequestDto implements IQueueDealMigrationRequestDto {
    bulkIds?: BulkIdsDto | undefined;
    forceResync!: boolean;

    constructor(data?: IQueueDealMigrationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bulkIds = _data["bulkIds"] ? BulkIdsDto.fromJS(_data["bulkIds"]) : <any>undefined;
            this.forceResync = _data["forceResync"];
        }
    }

    static fromJS(data: any): QueueDealMigrationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueueDealMigrationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bulkIds"] = this.bulkIds ? this.bulkIds.toJSON() : <any>undefined;
        data["forceResync"] = this.forceResync;
        return data;
    }

    clone(): QueueDealMigrationRequestDto {
        const json = this.toJSON();
        let result = new QueueDealMigrationRequestDto();
        result.init(json);
        return result;
    }
}

export interface IQueueDealMigrationRequestDto {
    bulkIds?: BulkIdsDto | undefined;
    forceResync: boolean;
}

export class TestDto implements ITestDto {
    prop?: string | undefined;

    constructor(data?: ITestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prop = _data["prop"];
        }
    }

    static fromJS(data: any): TestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prop"] = this.prop;
        return data;
    }

    clone(): TestDto {
        const json = this.toJSON();
        let result = new TestDto();
        result.init(json);
        return result;
    }
}

export interface ITestDto {
    prop?: string | undefined;
}

export class V1ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isV1ApiException = true;

    static isV1ApiException(obj: any): obj is V1ApiException {
        return obj.isV1ApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new V1ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}